import { PaymentType } from '@common/util-models';

export interface CheckoutSelectPaymentFormValue {
  paymentType: PaymentType;
}
